import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const InfoOutlineIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="info-circle" {...props} />;
};

export { InfoOutlineIcon };
